import {
  EditOutlined,
  SettingOutlined,
  InboxOutlined,
  UserOutlined,
  DiffOutlined,
} from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditDeviceModal from "../../helpers/admin/EditDeviceModal";
import {
  getAvailableStatusOptions,
  isStatusFieldDisabled,
  statusDisplayMap,
  transformDeviceData,
} from "../../helpers/admin/statusUtils";
import {
  fetchDevices,
  commCheckRequest,
} from "../../redux/deviceRegister/action";
import CommCheckModal from "../Admin/CommCheckModal";
import CommonLoader from "../Loaders/loader";

const DeviceManagement = () => {
  const dispatch = useDispatch();
  const { devices, isLoading } = useSelector((state) => state.deviceIdReducer);
  const currentProject = useSelector(
    (state) => state.data360LiveProjectReducer?.currentProject
  );
  const projectList = useSelector(
    (state) => state.data360LiveProjectReducer?.projectDetails?.projects || []
  );

  const projectNames = useMemo(
    () => projectList?.map((item) => item.project_name) || [],
    [projectList]
  );
  const projectNumber = useMemo(
    () => projectList?.map((item) => item.project_number) || [],
    [projectList]
  );
  const projectId = useMemo(
    () => projectList?.map((item) => item.project_id) || [],
    [projectList]
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editingDevice, setEditingDevice] = useState(null);

  useEffect(() => {
    dispatch(fetchDevices());
  }, [dispatch]);

  const rowData = transformDeviceData(devices);
  const filteredDevices = useMemo(() => {
    return rowData.filter((device) => {
      if (!device.Project || !currentProject?.project_name) return false;
      const projectMatch = device.Project.match(/^([^(]+)\(#([A-Za-z0-9-]+)\)$/);
      if (!projectMatch) return false;

      const deviceProjectName = projectMatch[1];
      return deviceProjectName === currentProject.project_name;
    });
  }, [rowData, currentProject]);

  const handleEdit = (device) => {
    setEditingDevice(device);
    setIsEditModalVisible(true);
  };

  const showModal = (device) => {
    dispatch(commCheckRequest({ Edge_UID: device.DeviceId }));
    setIsModalVisible(true);
  };

  if (isLoading && !devices.length) {
    return (
      <div className="slogdata-loader">
        <CommonLoader />
      </div>
    );
  }

  if (filteredDevices.length === 0) {
    return (
      <div className="slogdata-loader">
        <p>No Data Available</p>
      </div>
    );
  }

  return (
    <div className="device-management-container">
      <div className="devices-grid">
        {filteredDevices.map((device) => (
          <div key={device.DeviceId} className="device-card">
            <div className="device-content">
              <div className="device-header-device-mng">
                <h3 className="device-id">{device.DeviceId}</h3>
                <span className={`status-badge ${device.Status.toLowerCase()}`}>
                  {device.StatusDisplay}
                </span>
              </div>
              <div className="device-details">
                <div className="detail-row">
                  <UserOutlined />
                  <span>Project: {device.Project}</span>
                </div>
                <div className="detail-row">
                  <InboxOutlined />
                  <span> weld Type: {device.weldType}</span>
                </div>
                <div className="detail-row">
                  <DiffOutlined />
                  <span>welduid: {device.welduid}</span>
                </div>
              </div>
            </div>
            <div className="device-footer">
              <div className="firmware-info">
                {/* Updated:{" "}
                {device.updatedAt
                  ? new Date(device.updatedAt).toLocaleDateString("en-GB")
                  : "-"} */}
              </div>
              <div className="footer-icons">
                <Tooltip title="Edit Device">
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(device)}
                  />
                </Tooltip>
                <Button
                  type="text"
                  icon={<SettingOutlined className="setting-icon" />}
                  onClick={() => showModal(device)}
                >
                  Manage
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <EditDeviceModal
        visible={isEditModalVisible}
        device={editingDevice}
        projectNames={projectNames}
        projectNumber={projectNumber}
        projectId={projectId}
        statusDisplayMap={statusDisplayMap}
        getAvailableStatusOptions={getAvailableStatusOptions}
        isStatusFieldDisabled={isStatusFieldDisabled}
        onCancel={() => setIsEditModalVisible(false)}
      />

      <CommCheckModal
        isModalVisible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      />
    </div>
  );
};

export default DeviceManagement;
